import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const AutoModalSlideHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);
  const rightButtonFontURL = getFontURL(btnFontFamily?.right_button);
  const leftButtonFontURL = getFontURL(btnFontFamily?.left_button);

  const style = `
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }

  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }
  @font-face {
    font-family: 'multiButtonFont';
    src: url(${multiButtonFontURL});
    }
  @font-face {
    font-family: 'rightButtonFont';
    src: url(${rightButtonFontURL});
    }
  @font-face {
    font-family: 'leftButtonFont';
    src: url(${leftButtonFontURL});
    }
    
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 100%;
      padding: 0 38px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .modal_wrapper {
      width: 100%;
      padding: 1rem 0;
      padding-top: 2rem;

      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12rem;
    }
    .slick_wrapper .slick-list {
      <!-- padding: 0 -0.5rem; -->
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      margin: 0 0.5rem;
    }
    .slick_image_wrapper {
      min-width: 12rem;
      max-width: 12rem;
      min-height: 12rem;
      max-height: 12rem;
      outline: 0;
      overflow: hidden;
      border-radius: ${radius?.multi_image}px;
    }
    .slick_image_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;      
      border-radius: ${radius?.multi_image}px;
    }

    .contents_box {
      width: 100%;
      padding: 0 1rem;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'titleFont'
      };
    }

    .slick-dots {
      margin-top: 1rem;
    }
    .slick-dots,
    .slick-dots li {
      height: 0.25rem;      
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }
    .slick-dots button {
      width: 0.25rem;
      height: 0.25rem;

      font-size: 0;
      border: 0;
      outline: 0;
      border-radius: 999px;
      background-color: rgba(0, 0, 0, .3);
    }
    .slick-dots li.slick-active button {
      background-color: #000;
    }

    .contents_box .sub_title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
    }
    .sub_title .sub_title_inner {
      width: 100%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitleFont'
      };
    }

    .bar_wrapper {
      height: 0.25rem;
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily.multi_button
          : 'multiButtonFont'
      };
      
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
      height: 1.25rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.left_button};
      font-weight: ${btnFontWeight?.left_button};
      font-size: ${btnFontSize?.left_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.left_button
        )
          ? btnFontFamily.left_button
          : 'leftButtonFont'
      };
      background-color:rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  }, ${btnBgColorB?.left_button}, ${btnBgColorA?.left_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      color: ${btnColor?.right_button};
      font-weight: ${btnFontWeight?.right_button};
      font-size: ${btnFontSize?.right_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.right_button
        )
          ? btnFontFamily.right_button
          : 'rightButtonFont'
      };
      background-color:rgba(${btnBgColorR?.right_button},${
    btnBgColorG?.right_button
  }, ${btnBgColorB?.right_button}, ${btnBgColorA?.right_button});
    }

		@media screen and (min-width: 568px) and (max-width: 1024px) {
      .center {
        width: 314px;
        padding: 0px;
        }
    }
  `;

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="center">
        <div class="modal_wrapper">
          <div class="contents_box">
            <div class="title">
              <div class="title_inner">${changeEnterHTML(text?.title)}</div>
            </div>
            <div class="sub_title">
              <div class="sub_title_inner">${changeEnterHTML(
                text?.sub_title
              )}</div>
            </div>
          </div>
          <div class="slick_wrapper">
            <div class="slick_slider">${bgImage?.multi_image
              ?.map(
                (data: any, idx: number) => `<div class="slick_image_wrapper">
          <img class="image" src="${
            data && data !== '' ? data : modalSlickAlt
          }" alt="" />
        </div>`
              )
              .join('')}
            </div>
          </div>
          <div class="bar_wrapper"></div>
          <div class="btn_wrapper">
            <button class="btn_inner"></button>
          </div>
        </div>
        <div class="bottom_wrapper">
          <span class="style01">${btnText?.left_button}</span>
          <span class="style02">${btnText?.right_button}</span>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = '[';
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_button?.length; i++) {
    button_list += `['${btnText?.multi_button?.[i]}']`;
    if (i !== btnText?.multi_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_button?.[i]}', '${tracking?.left_button?.[i]}', '${tracking?.right_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'AUTO MODAL SLIDE',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      $('.slick_slider').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2500,
    
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        speed: 300,
        touchThreshold: 300
      });

      let currentIndex = 0;
      let button = ${button_list};
      $('.btn_inner').text(button[0][0]);
      $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        currentIndex = $('.slick_slider').slick('slickCurrentSlide');
        $('.btn_inner').text(button[currentIndex][0]);
      });

      let deeplink = ${deeplink_list};
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.image').click(function() {
        appboyBridge.logClick(tracking[currentIndex][0]);
        try {
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.btn_wrapper').click(function() {
        appboyBridge.logClick(tracking[currentIndex][1]);
        try {
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });

      $('.style01').click(function() {       
        appboyBridge.logClick(tracking[currentIndex][2]);
        try{
          if("${btnAgain?.type}"==="attribute"){
            appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.left_button}", new Date());
          }
          if("${btnAgain?.type}"==="event"){
            appboyBridge.logCustomEvent("${btnAgain?.left_button}");
          }
        }catch(err){}

        try {
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });

      $('.style02').click(function() {
        appboyBridge.logClick(tracking[currentIndex][3]);
        try {
          if (button1[3].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[3].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        {/* jquery */}
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default AutoModalSlideHTML;
